{
  "$schema": "./schema.json",
  "formFields": {
    "companyLabel": "Yritys",
    "companyPlaceholder": {
      "SE": "Yritys AB tai XXXXXX-XXXX",
      "FI": "Yritys OY tai 1234567-8"
    },
    "companyErrors": {
      "orgNumberRequired": "Y-tunnus vaaditaan",
      "orgNumberInvalid": "Syötä kelvollinen Y-tunnus",
      "orgNameRequired": "Yrityksen nimi vaaditaan"
    },
    "companyFindHelp": "Etkö löydä yritystäsi? Syötä Y-tunnuksesi.",
    "companyPreloader": "Haetaan...",
    "companyChange": "Muuta",
    "companySelect": "Valitse",
    "emailLabel": "Sähköposti",
    "emailPlaceholder": {
      "SE": "kontakti@yritys.se",
      "FI": "kontakti@yritys.fi"
    },
    "emailErrors": {
      "invalid": "Virheellinen sähköpostiosoite",
      "required": "Sähköposti vaaditaan",
      "validationError": "Anna kelvollinen sähköpostiosoite"
    },
    "phoneLabel": "Matkapuhelinnumero",
    "phonePlaceholder": {
      "SE": "070 000 00 00",
      "FI": "050 0000 000"
    },
    "phoneErrors": {
      "invalid": "Puhelinnumero on virheellinen",
      "required": "Puhelinnumero vaaditaan"
    },
    "amountLabel": "Haluamasi rahoitus",
    "limitedCompanyConfirmation": "Osakeyhtiö",
    "requestedAmountErrors": {
      "typeError": "Käytä vain numeroita",
      "required": "Valitse summa"
    },
    "consentError": "Sinun on hyväksyttävä, että käsittelemme henkilötietojasi",
    "privacyPolicyConsent": "Hyväksyn, että {{company}} käsittelee <1>henkilötietojani</1>",
    "minimumAmountError": "Pienin haettava summa on {{amount}}"
  }
}
